<template>
  <div class="home_page" style="height: 100vh">
    <el-container style="height: 100vh">
      <el-header :style="{ backgroundColor: color }">
        <rowheader :isCollapse="isCollapse" @statusClick="statusClick"></rowheader>
      </el-header>
      <!-- style="background: #eef5f9" -->
      <el-container>
        <asideMuen :isCollapse="isCollapse"></asideMuen>
        <el-main class="scroll">
          <el-backtop target=".scroll" :bottom="120" :right="40"></el-backtop>
          <div>
            <div>
              <el-tabs v-model="activeIndex" closable type="card" v-if="openTab.length" @tab-click="tabClick"
                @tab-remove="tabRemove">
                <el-tab-pane :disabled="item.disabled" :key="item.name" v-for="item in openTab" :label="item.name"
                  :name="item.route">
                  <Breadcrumb></Breadcrumb>
                </el-tab-pane>
              </el-tabs>
              <keep-alive>
                <router-view v-if="$route.meta.keepAlive"></router-view>
              </keep-alive>
              <router-view v-if="!$route.meta.keepAlive"></router-view>
            </div>
          </div>
        </el-main>
        <right-panel>
          <settings />
        </right-panel>
      </el-container>
    </el-container>
  </div>
</template>
<script>
/**
 * 主布局组件
 * 功能：组合顶栏/侧边栏/多标签页（可关闭 tab）/keep-alive 路由缓存/右侧设置面板，窗口 resize 联动侧栏收起与 CSS 变量
 */
import rowheader from "../container/headerMenu/";
import asideMuen from "./components/sidebar";
import Breadcrumb from "../common/breadcrumbHeader";
import RightPanel from "../common/RightPanel";
import settings from "./components/settings";
import Watermark from "../common/waterMarker/index"
export default {
  components: {
    rowheader,
    asideMuen,
    Breadcrumb,
    RightPanel,
    settings,
  },
  data() {
    return {
      isCollapse: false,
      isPc: true,
      screenWidth: document.documentElement.clientWidth,
    };
  },
  mounted() {
    if (this.$route.path !== "/" && this.$route.path !== "/homePage") {
      this.$store.commit("add_tabs", { route: "/homePage", name: "首页" });
      this.$store.commit("add_tabs", {
        route: this.$route.path,
        name: this.$route.meta.title,
      });
      this.$store.commit("set_active_index", this.$route.path);
    } else {
      this.$store.commit("add_tabs", {
        route: "/homePage",
        name: "首页",
        disabled: true,
      });
      this.$store.commit("set_active_index", "/homePage");
      this.$router.push("/homePage");
    }
    const that = this;
    window.onresize = () => {
      return (() => {
        window.screenWidth = document.body.clientWidth;
        that.screenWidth = window.screenWidth;
      })();
    };
  },
  computed: {
    /** 已打开的多标签页列表，来自 store */
    openTab() {
      return this.$store.getters.openTab;
    },
    /** 顶栏背景色，来自 store 的主题色 */
    color() {
      return this.$store.getters.color;
    },
    activeIndex: {
      get() {
        return this.$store.getters.activeIndex;
      },
      set(val) {
        this.$store.commit("set_active_index", val);
      },
    },
    /** 当前登录用户名，来自 store，用于设置水印 */
    userName() {
      return this.$store.getters.userName
    }
  },
  watch: {
    $route(to, from) {
      let flag = false;
      for (let item of this.openTab) {
        //  && to.meta.title !== "邮件详情"
        if (item.name === to.meta.title) {
          this.$store.commit("set_active_index", to.path);
          flag = true;
          break;
        }
      }
      if (!flag) {
        this.$store.commit("add_tabs", { route: to.path, name: to.meta.title });
        this.$store.commit("set_active_index", to.path);
      }
    },
    screenWidth: function (val) {
      if (val < 1500) {
        this.isCollapse = true;
        this.width = null;
      } else {
        this.isCollapse = false;
        this.width = "220px";
      }
      this.elmain(val);
    },
    userName(val) {
      // 设置水印
      Watermark.set(val);
    }
  },
  methods: {
    // 隐藏展开菜单
    statusClick(val) {
      this.isCollapse = val;
      this.elmain();
    },
    /** 根据侧栏收起状态与窗口宽度同步 CSS 变量 --label-left/--label-width */
    elmain(val) {
      let ckwidth = val;
      let boomm = ckwidth;
      if (ckwidth < 1600) {
        boomm = 1600;
      }
      if (this.isCollapse || ckwidth < 1500) {
        // 当前窗口总宽度
        boomm = boomm - 65;
        document
          .getElementsByTagName("body")[0]
          .style.setProperty("--label-width", boomm + "px");
        document
          .getElementsByTagName("body")[0]
          .style.setProperty("--label-left", "65px");
      } else {
        boomm = boomm - 200;
        document
          .getElementsByTagName("body")[0]
          .style.setProperty("--label-width", boomm + "px");
        document
          .getElementsByTagName("body")[0]
          .style.setProperty("--label-left", "200px");
      }
    },
    //tab标签点击时，切换相应的路由
    tabClick() {
      // this.$route.meta.keepAlive = true;
      this.$router.push({ path: this.activeIndex });
    },
    //移除tab标签
    tabRemove(targetName) {
      // this.$route.meta.keepAlive = false;
      //首页不删
      if (targetName == "/" || targetName == "/homePage") {
        this.disabled = true;
        return;
      }
      // this.$route.meta.keepAlive = false;
      this.$store.commit("delete_tabs", targetName);
      if (this.activeIndex === targetName) {
        // 设置当前激活的路由
        if (this.openTab && this.openTab.length >= 1) {
          this.$store.commit(
            "set_active_index",
            this.openTab[this.openTab.length - 1].route
          );
          this.$router.push({ path: this.activeIndex });
        } else {
          this.$router.push({ path: "/" });
        }
      }
    },
  },
};
</script>
<style lang="scss" scoped>
$ansleft: var(--label-left, 200px);
$answidth: var(--label-width, auto);
$tabbg: var(--tab-bg, "");
$headerwidth: var(--headerwidth, auto);
$container: var(--container, auto);

.el-header {
  color: #333;
  text-align: center;
  box-shadow: 0 0 5px rgba(18, 23, 39, 0.5);
  padding: 0px 0px !important;
  position: relative;
  height: 60px;
}

.headContainer {
  height: 100%;
  overflow: auto;
  padding: 0 20px;
}

.el-aside {
  display: block;
  position: absolute;
  left: 0;
  top: 60px;
  bottom: 0;
}

.el-main {
  position: absolute;
  left: $ansleft;
  width: $answidth;
  right: 0;
  top: 60px;
  bottom: 0;
  overflow-y: scroll;
  padding: 20px;
  // padding-left: 10px;
}
</style>
